import { Capability } from "../types/catalog";
import { orgIsInLaunchDarkly } from "./launchDarklyUtils";

type LegacyBillingFlags = {
  allowChargeItems?: boolean;
  billingFeature?: boolean;
  billingEnabled?: unknown;
};

/**
 * Org-level patient-billing eligibility from entitlements.
 * Covers legacy virtual entitlements and onboarded BILLING addon.
 */
export function hasEntitlementBillingAccess(
  capabilities?: Record<string, Capability | boolean> | null,
): boolean {
  const billingCap = capabilities?.billing_access;
  return typeof billingCap === "object" && billingCap?.enabled === true;
}

/**
 * Legacy LD allow-list for patient billing.
 * Historically finance UI used `allowChargeItems` and encounter charges used
 * `billingFeature`; treat either as sufficient when the org is in `billingEnabled`.
 * Matches both Mongo `id` and Auth0 `authId`, same as `shouldRenderMenuItem`.
 */
export function hasLegacyLdBillingAccess(
  flags: LegacyBillingFlags,
  organizationId?: string | null,
  authId?: string | null,
): boolean {
  if (!orgIsInLaunchDarkly(flags.billingEnabled, organizationId, authId)) {
    return false;
  }
  return !!flags.allowChargeItems || !!flags.billingFeature;
}

/** Entitlements billing_access or legacy LD allow-list. */
export function orgHasPatientBillingAccess(
  capabilities: Record<string, Capability | boolean> | null | undefined,
  flags: LegacyBillingFlags,
  organizationId?: string | null,
  authId?: string | null,
): boolean {
  return (
    hasEntitlementBillingAccess(capabilities) ||
    hasLegacyLdBillingAccess(flags, organizationId, authId)
  );
}
